interface StateProps {
  title: string;
  message?: string;
}

export function EmptyState({ title, message }: StateProps) {
  return (
    <div className="vn-state">
      <div className="vn-state__title">{title}</div>
      {message ? <p style={{ margin: '0 auto' }}>{message}</p> : null}
    </div>
  );
}

export function ErrorState({
  title = 'Something went wrong',
  message = 'We could not load this content. Please refresh the page or try again shortly.',
}: Partial<StateProps>) {
  return (
    <div className="vn-state vn-state--error" role="alert">
      <div className="vn-state__title">{title}</div>
      <p style={{ margin: '0 auto' }}>{message}</p>
    </div>
  );
}

export function LoadingState({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="vn-state" role="status" aria-live="polite">
      <div className="vn-spinner" aria-hidden="true" />
      {label}
    </div>
  );
}
